<template>
  <div>
    <div v-show="showMap" class="svg-container">
      <!--tool bar-->
      <div>
        <div>
          <span class="iconfont iconxiazai" @click="handleDownloadPic" />
        </div>
        <div>
          <span class="iconfont iconuclose" @click="handleMarkmap" />
        </div>
      </div>
      <svg id="svgmap"></svg>
    </div>

    <div id="test"></div>
    <link rel="stylesheet" href="/editor.md/css/editormd.css" />
    <!-- 中间内容区域 -->
    <div class="detail-center" :style="{ width: isZoom ? fullScreen : '700px' }">
      <!-- 错误块 -->
      <div class="article-error" v-if="article_error_visible">
        <img src="~/assets/img/not_fount.png" />
        <p class="small-text">您要找的页面不存在</p>
        <p class="normal-text">可能是因为您的链接地址有误、该文章已经被作者删除或转为私密状态。</p>
      </div>

      <!-- 文章模块 -->
      <div class="article-container" v-if="!article_error_visible">
        <!--工具按钮条-->
        <div class="toolbar">
          <!--显示脑图-->
          <div @click="handleMarkmap">
            <span class="iconfont iconmind-map"></span>
          </div>
          <!-- 文章缩放 -->
          <div @click="handleZoom">
            <img style="width:20px" src="~/assets/img/enlarge.png" v-show="!isZoom" />
            <img class="narrow-icon" style="width:20px; margin: 18px 38px 0 0" src="~/assets/img/narrow.png"
                 v-show="isZoom" />
          </div>
        </div>
        <!-- 文章信息 -->
        <div class="article-info" v-if="article_id">
          <h1 class="article-title">{{ article_info.title }}</h1>
          <p class="article-tag" style="margin-top: 10px">
            <span v-for="item in article_info.tags">
              {{ item.tag }}
            </span>
          </p>
          <p class="article-time">
            <span class="time ">发布时间：<el-button type="text" @click="showPublishTimeDetail">{{ show_publish_time }}</el-button></span>
            <span class="time">更新时间：<el-button type="text" @click="showModifyTimeDetail">{{ show_modify_time }}</el-button></span>
            <span v-if="import_src && import_url"> | <a :href="import_url" class="normalA" target="_blank">{{ import_src }} 查看原文</a></span>
          </p>
          <div class="nearby-article-wrap-top">
            <div class="nearby-article-wrap">
              <p class="nearby-article-item ellipsis">
                <nuxt-link
                  v-show="next_article.aid"
                  class="title ellipsis"
                  :to="{name: 'book-uid-detail', params: {uid: $route.params.uid, detail: next_article.aid}}">
                  <i class="el-icon-caret-left"></i>
                  <span class="title-filename ellipsis">{{ next_article.filename }}</span>
                </nuxt-link>
              </p>
              <p class="nearby-article-home" @click="showCatalogMenu"><img src="~/assets/img/home@2x.png" alt=""></p>
              <p class="nearby-article-item nearby-article-item_right ellipsis">
                <nuxt-link
                  v-show="prev_article.aid"
                  class="title ellipsis"
                  :to="{name: 'book-uid-detail', params: {uid: $route.params.uid, detail: prev_article.aid}}"
                >
                  <span class="title-filename ellipsis">{{ prev_article.filename }}</span>
                  <i v-show="prev_article.aid" class="el-icon-caret-right"></i>
                </nuxt-link>
              </p>
            </div>
          </div>
        </div>

        <!-- 正文内容 -->
        <article v-html="docHtml" class="render-content"
                 :class="{'editormd-html-preview-zoom': isZoom,
                 'markdown-body': isMD,
                 'editormd-html-preview': isMD,
                 'fh-html': !isMD }">
        </article>

        <div class="nearby-article-wrap-bottom">
          <div class="nearby-article-wrap">
            <p class="nearby-article-item ellipsis">
              <nuxt-link v-show="next_article.aid"
                class="title ellipsis"
                :to="{name: 'book-uid-detail', params: {uid: $route.params.uid, detail: next_article.aid}}">
                <i class="el-icon-caret-left"></i>
                <span class="title-filename ellipsis">{{ next_article.filename }}</span>
              </nuxt-link>
            </p>
            <p class="nearby-article-home" @click="showCatalogMenu"><img src="~/assets/img/home@2x.png" alt=""></p>
            <p class="nearby-article-item nearby-article-item_right ellipsis">
              <nuxt-link
                v-show="prev_article.aid"
                class="title ellipsis"
                :to="{name: 'book-uid-detail', params: {uid: $route.params.uid, detail: prev_article.aid}}"
              >
                <span class="title-filename ellipsis">{{ prev_article.filename }}</span>
                <i v-show="prev_article.aid" class="el-icon-caret-right"></i>
              </nuxt-link>
            </p>
          </div>
        </div>

        <!-- 操作 -->
        <div class="article-operator">
          <span class="operator-tiem">
            <i class="ion-heart"></i>
            <a @click="handleArticleLike">点赞({{ this.article_info ? this.article_info.like_num : 0 }})</a>
          </span>
          <span class="operator-item">
            <i class="ion-eye" style="color: #F6CA1C;"></i>
            <a>阅读({{ this.article_info ? this.article_info.uv_num : 0 }})</a>
          </span>
          <span class="operator-item">
            <i class="ion-android-warning" style="color: #F6CA1C;"></i>
            <a @click="dialog_report_visible = true">举报</a>
          </span>
        </div>
      </div>

      <!-- 评论内容 -->
      <div class="comment">
        <!-- 评论表单 -->
        <div class="form-row" v-show="isPC">
          <div class="commont-user-info">
            <img :src="userInfo.pic" v-if="userInfo.pic" />
            <img v-else src="~/assets/img/anonymous.png" alt="">
            <p>{{ userInfo.nick }}</p>
          </div>
          <div class="form-input">
            <textarea v-model="edit_common_content"></textarea>
            <el-button size="small" @click="addComment">发表评论</el-button>
          </div>
        </div>

        <div v-if="isPC">
          <comment-detail :aid="parseInt(article_id)" v-for="item in comment_list" :data="item" :key="item.id" ></comment-detail>
          <!-- 评论加载 loading -->
          <div class="comment-loading" v-if="comment_loading" v-loading="true" style="height: 60px"></div>
          <div class="not-have-comment" style="padding: 10px; text-align: center" v-if="!have_comment">没有更多了</div>
        </div>
        <div class="comment-list" v-else>
          <div class="mobile-comment-title">评论</div>
          <div class="comment-item" v-for="(item, index) in comment_list">
            <div class="mobile-comment-header">
              <!-- 头像 -->
              <img v-if="item.pic" :src="item.pic">
              <img v-else src="~/assets/img/anonymous.png" alt="">

              <!-- 时间和用户名 -->
              <div class="mobile-comment-name">
                <p class="name">{{item.nickname}}</p>
                <p class="time">{{item.time}}</p>
              </div>

              <div class="mobile-comment-op">
                <span style="margin-right: 10px;"><a @click="handleCommentLike(item.id)"><i class="ion-ios-heart"></i></a> </span>
                <span><a :data-item="JSON.stringify(item)" :data-index="index" class="reply-btn"><i class="ion-android-textsms"></i></a> </span>
              </div>
            </div>

            <div class="mobile-comment-content">
              <div class="content-box" v-html="htmlDecodeByRegExp(item.content)"></div>

              <div class="child-comment" v-if="item.children">
                <div class="child-comment-item" v-for="(child, child_index) in item.children">
                  <a class="reply-btn" :data-item="JSON.stringify(child)" :data-index="index">
                    <span class="child-name">{{child.showNick || child.nickname}}:</span>
                    <span class="child-content" v-html="htmlDecodeByRegExp(child.content)"></span>
                  </a>
                </div>
              </div>
            </div>

          </div>

          <!-- 评论加载 loading -->
          <div class="comment-loading" v-if="comment_loading" v-loading="true" style="height: 60px"></div>
          <div class="not-have-comment" style="padding: 10px; text-align: center" v-if="!have_comment">没有更多了</div>

          <div style="height: 40px"></div>
          <!-- 评论框 -->
          <div class="mobile-comment-input-box" v-clickoutside="clearSelect">
            <input v-model="edit_common_content" id="reply-input" type="text" :placeholder="reply_nick" />
            <button @click="addComment">发送</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 右侧导航 -->
    <div class="detail-right" v-if="!isZoom">
      <div class="sidebar">
        <div class="sticky-block-box">
          <div class="sidebar-title">文章标题</div>
          <!-- 目录占位符 -->
          <div class="markdown-body editormd-preview-container sidebar-content bold5" id="custom-toc-container">
            <div class="markdown-toc editormd-markdown-toc el-tree-wrap">
              <el-tree
                :data="treeTitles"
                node-key="id"
                default-expand-all
                :expand-on-click-node="false"
                empty-text=""
                class="markdown-toc-list"
                @node-click="handleClickAnchor"
                :indent="24"
              >
                 <span
                   class="custom-tree-node"
                   :class="{'custom-tree-node_isLeaf': node.isLeaf}"
                   slot-scope="{ node, data }"
                 >
                   <a
                     class="anchor-a"
                     :class="{'active': data.isActive}"
                     :id="data.anchorId"
                   > {{ data.title }}</a>
                 </span>
              </el-tree>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- 举报弹窗 -->
    <el-dialog :visible="dialog_report_visible" @close="dialog_report_visible = false" title="举报信息" width="80%" style="max-width: 600px; margin: 0 auto;">
      <div style="text-align: right;">
        <textarea v-model="report_content" style="display: block;width: 100%;height: 200px;padding: 10px;"></textarea>
        <el-button size="mini" style="margin-top: 10px;" @click="handleArticleReport">提交</el-button>
      </div>
    </el-dialog>

    <current-menu-bar :visible="show_left_offcanvas" @close="show_left_offcanvas=false">
      <div id="right-offcanvas">
        <div style="text-align: center;border-bottom: 1px solid #eee; padding-bottom: 5px; font-size: 14px; color: #606266;">文章标题</div>
        <div class="markdown-body editormd-preview-container sidebar-content bold5">
          <div class="markdown-toc editormd-markdown-toc el-tree-wrap">
            <el-tree
              :data="treeTitles"
              node-key="id"
              default-expand-all
              :expand-on-click-node="false"
              empty-text=""
              class="markdown-toc-list"
              @node-click="handleClickAnchor"
              :indent="24"
            >
                 <span
                   class="custom-tree-node"
                   :class="{'custom-tree-node_isLeaf': node.isLeaf}"
                   slot-scope="{ node, data }"
                 >
                   <a
                     class="anchor-a"
                     :class="{'active': data.isActive}"
                     :id="data.anchorId"
                   > {{ data.title }}</a>
                 </span>
            </el-tree>
          </div>
        </div>
      </div>
    </current-menu-bar>

    <div class="fixed-catalog-wrap">
      <div
        class="fixed-catalog-wrap-item"
        @click="showCatalog = !showCatalog"
        :class="{'fixed-catalog-wrap-icon': showCatalog}"
      >
        <img src="~/assets/img/arrow-down.png" alt="">
      </div>
      <div
        class="fixed-catalog-wrap-item"
        v-if="!showCatalog"
        @click="showCatalogMenu"
      >
        目录
      </div>
      <div
        class="fixed-catalog-wrap-item"
        v-if="!showCatalog"
        @click="showRightMenu"
      >
        标题
      </div>

    </div>

    <div class="image-dialog" v-show="show_img_dialog">
      <div class="modal" @click="hiddenImgDialog"></div>
      <div id="dialog-img-box">
        <img :src="img_dialog_url"/>
      </div>
    </div>
    <el-dialog
      :visible="selectArticleVisible"
      @close="selectArticleVisible = false"
      title="温馨提示"
      width="80%"
      style="max-width: 600px; margin: 0 auto;"
    >
      <p>{{selectDialogTitle}}</p>
      <div class="select-article-wrap">
        <div
          v-for="(item) in matches"
          :key="item.path"
          class="select-article-item"
        >
          <nuxt-link
            @click.native="selectArticleVisible = false"
            class="select-article-item-title-wrap normalA"
            :to="{name: 'book-uid-detail', params: {uid: routeParams.uid, detail: item.aid}, hash: $route.hash}"
          >
            <div class="select-article-item-title ellipsis">
              {{item.title}}
              <p class="select-article-item-title_path">{{item.path}}</p>
            </div>
            <i class="el-icon-arrow-right arrow-icon"></i>
          </nuxt-link>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import save from 'save-svg-as-png';
  import {
    addComment,
    addReport,
    articleLike,
    commentLike,
    getArticleInfo,
    getComment
  } from "~/utils/api";
  import * as apis from "~/utils/api";
  import {SUCCESS} from "~/utils/status-code";
  import {
    getDateStr,
    getTimeDifferenceByNow,
    parseList,
    parseListForMobile,
    successMsg,
    errorMsg,
    infoMsg,
    scrollLoad,
    uuid,
    findCountInArr,
    fetchScript,
    getExtensionFromPath,
  } from "~/utils/tools";
  import CommentDetail from "~/components/comment-detail";
  import { mapState } from 'vuex';
  import Clickoutside from '~/utils/dom/clickoutside';
  import Vue from 'vue';
  import CurrentMenuBar from "../../../components/current-menu-bar";
  import {addClass, removeClass} from '../../../utils/dom/dom';
  import preImg from '~/utils/previewImg';
  import {throttle} from "lodash";

  export default {
    name: 'book-detail',
    components: {CurrentMenuBar, CommentDetail},
    head() {
      return {
        title: this.article_info.title
      }
    },
    data() {
      return {
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        show_img_dialog: false,
        img_dialog_url: "",
        img_dialog_style: {},
        titles: [], // 文章标题数据，列表结构，用于双向定位
        treeTitles: [], // 文章标题数据，树形结构，用于 el-tree 显示
        isMD: true, // 是否 markdown 格式
        article_id: 0,
        article_error_visible: false,
        // 是否显示举报弹窗
        dialog_report_visible: false,
        docHtml: '',
        docMD: '',
        matches: [], // 是否有匹配上的ids
        selectArticleVisible: false,
        article_info: {
          title: "",
          publish_time: "",
          modify_time: "",
          tags: [],
          uv_num: 0,
          like_num: 0,
          is_like_bool: false
        },

        show_publish_time: "",
        show_modify_time: "",
        // 举报内容
        report_content: "",
        // 评论列表
        comment_list: [],
        // 评论编辑框内容
        edit_common_content: "",

        // 是否显示左侧边目录
        show_left_offcanvas: false,
        showCatalog: false,
        reply_id: 0,
        reply_source_id: 0,
        reply_nick: "评论",
        reply_index: 0,
        reply_item: null,
        is_select: false,
        prev_article: {
          filename: "",
          aid: ""
        },
        next_article: {
          filename: "",
          aid: ""
        },
        import_src: "",
        import_url: "",

        comment_loading: false,
        have_comment: true, // 记录服务器是否还有评论
        fullScreen: "",
        isPC: true,
        getArticleContentComplete: false, // 是否获取到了文章内容
        markmap: null, // 不为空则直接显示，不再重新 render
        showMap: false,
      }
    },

    directives: {
      Clickoutside
    },
    computed: {
      ...mapState('auth', [
        'userInfo',
        'isLogin'
      ]),
      ...mapState('editor', [
        'isZoom',
      ]),
      routeParams() {
        return this.$route.params;
      },
      selectDialogTitle() {
        const hash = this.$route.hash;
        return this.article_error_visible ?
          `找不到此文章，但在以下文章中找到了 "${hash}"，请选择您想要阅读的文章` :
          `当前文章中并不包含 "${hash}"，但在以下文章中包含，请选择您想要阅读的文章`;
      },
    },
    watch: {
      $route(to, from) {
        this.getArticleContentComplete = false;
        if (to.params.uid !== from.params.uid || to.params.detail !== from.params.detail) {
          svgmap.innerHTML = ""; // 进入新的文章了，清空当前绘制的数据
        }
        this.initMarkmap();
      },
      comment_list(val) {
        this.$nextTick(() => {
          // 仅响应式时有效
          let replyBtnArray = document.getElementsByClassName("reply-btn");
          for (let i = 0; i < replyBtnArray.length; i++) {
            let replyBtnItem = replyBtnArray[i];
            // 先移除事件，否则事件会多次注册
            replyBtnItem.removeEventListener('click', this.reply_comment);
            replyBtnItem.addEventListener('click', this.reply_comment)
          }
        })
      },
      article_id() {
        if (!this.article_id) {
          return;
        }
        this.scrollIntoCurrentArt();
        setTimeout(() => {
          this.getTitles();
          if (this.getArticleContentComplete) {
            this.handleHashSearch();
            this.handleDocLoaded();
          }
          this.monitorImgLoad();
          this.onResize();
          this.comment_list = [];
          this.loader(null, true);
        }, 10);
      },
      titles() {
        this.handleHashChange();
      },
    },

    async asyncData(app) {
      const { store, route } = app;
      const article_id = route.params.detail;
      if (!article_id) {
        return {
          getArticleContentComplete: true,
        };
      }
      try {
        const res = await apis.getArticleContent(article_id);
        let article_info = {
          title: res.info.title,
          publish_time: res.info.time,
          modify_time: res.info.updata_time,
          tags: [...res.info.tags.art_artag, ...res.info.tags.art_artag_classify, ...res.info.tags.art_artag_user],
        };

        const res1 = await getArticleInfo(article_id);
        if (parseInt(res1.errno) === SUCCESS.code) {
          article_info = {
            ...article_info,
            uv_num: res1.data.uv_num,
            like_num: res1.data.like_num,
            is_like_bool: res1.data.is_like_bool,
          }
        }
        return {
          article_id,
          article_error_visible: false,
          article_info,
          isMD: res.isMD,
          docHtml: res.data,
          docMD: res.mdData.replace(/\[id:(\w+)\]/g, ''),
          show_publish_time: getTimeDifferenceByNow(res.info.time, res.stime) + "前",
          show_modify_time: getTimeDifferenceByNow(res.info.updata_time, res.stime) + "前",
          prev_article: res.info.notree.after || {},
          next_article: res.info.notree.before || {},
          import_src: res.info.import_src,
          import_url: res.info.import_url,
          getArticleContentComplete: true,
        }
      } catch (err) {
        console.log('getArticleContent', err);
        if (err.errno === -1207) {
          return {
            article_error_visible: true,
            getArticleContentComplete: true,
            article_id,
          };
        }
      }
      return { getArticleContentComplete: true };
    },
    async mounted() {
      this.scrollIntoCurrentArt();
      this.handleDocLoaded();

      this.loader = scrollLoad(this, 1000, "comment_loading", () => {
        return this.getComment(this.comment_list.length);
      });
      this.article_id = this.$route.params.detail;

      window.addEventListener("scroll", this.handleScroll);
      window.addEventListener("hashchange", this.handleHashChange);
      window.addEventListener('resize', this.onResize);
      window.addEventListener('keydown', this.onKeyDown);
      document.querySelector(".render-content").addEventListener("click", this.handleClickBody, true);

      if (! this.article_id) {
        return false;
      }
      setTimeout(() => {
        this.getTitles();
        this.handleHashSearch();
        this.monitorImgLoad();
      }, 0);
      // force load comment once, after article id is set
      this.loader(null, true);
      this.onResize();
      this.registerBus();
      const html = document.getElementsByTagName('html')[0];
      html.setAttribute('style', "height: auto");
      this.initMarkmap();
    },
    beforeDestroy() {
      window.removeEventListener("hashchange", this.handleHashChange);
      window.removeEventListener("scroll", this.handleScroll);
      window.removeEventListener("resize", this.onResize);
      window.removeEventListener('keydown', this.onKeyDown);
      document.querySelector(".render-content").removeEventListener('click', this.handleClickBody, true);
      this.$Bus.$off('changeArticleInfo');
      const html = document.getElementsByTagName('html')[0];
      html.setAttribute('style', "height: 100%");
      this.destroied = true;
    },

    methods: {
      registerBus() {
        this.$Bus.$on('changeArticleInfo', (data) => {
          const { title } = data;
          if (title) {
            this.article_info.title = title;
          }
        })
      },
      judgeIdsInTitles(hid) {
        return this.titles.map(({id}) => (id)).includes(hid);
      },
      async handleHashSearch() {
        this.$nextTick(() => {
          const hash = this.$route.hash;
          if (!hash) return false;
          const hid = hash.replace('#', '');
          // 没有查找或者hid不在当前文章中才去调用接口查询
          if (this.article_error_visible || !this.judgeIdsInTitles(hid)) {
            apis.getHeadingMatches(hid, this.routeParams.uid).then(({ data }) => {
              this.matches = data;
              const len = this.matches.length;
              // 查到了唯一的文章，并且文章id与显示的文章id一致，则不处理
              if (!(len === 1 && this.matches[0].aid === this.article_id) && len > 0) {
                this.selectArticleVisible = this.matches.length > 0;
              }
            })
          }
        }, 0);
      },
      onResize(){
        this.isPC = document.body.clientWidth > 650;
        this.fullScreen = `${document.body.clientWidth}px`
      },
      onKeyDown(event) {
        if (event.altKey && event.key === "x") {
          event.preventDefault();
          this.handleMarkmap();
        } else if (event.key === "Escape") {
          this.$router.push({});
        }
      },

      // 初始化并显示 markmap if needed
      async initMarkmap() {
        this.showMap = this.$route.query.showMarkmap !== undefined;
        if (this.showMap && !this.markmap) {
          if (!this.isMD) {
            infoMsg("当前文档不是 markdown 格式，暂不支持显示为脑图");
            return;
          }

          await fetchScript('/markmap/d3@6.js');
          await fetchScript('/markmap/markmap-lib.js');
          await fetchScript('/markmap/markmap-view.js');

          const { markmap } = window;
          const { Transformer } = markmap;
          const transformer = new Transformer();
          const { root, features } = transformer.transform(this.docMD);
          const { styles, scripts } = transformer.getAssets();
          const { Markmap, loadCSS, loadJS } = markmap;
          if (styles) loadCSS(styles);
          if (scripts) loadJS(scripts, { getMarkmap: () => markmap });
          this.markmap = Markmap.create("#svgmap", null, root);
        }
      },

      // 切换脑图显示
      handleMarkmap() {
        if (this.showMap) {
          this.$router.push({});
        } else {
          this.$router.push({
            query: {showMarkmap: ''},
          });
        }
      },

      handleDownloadPic() {
        save.saveSvgAsPng(document.getElementById("svgmap"), "save.png", {
          backgroundColor: '#FFFFFF',
          scale: 5,
          width: window.innerWidth,
        }).catch((err)=>{
          console.log(err);
          errorMsg("保存图片失败!");
        });
      },

      /**
       * 浏览器前进、后退导航时定位
       */
      handleHashChange() {
        const anchor = decodeURIComponent(window.location.hash);
        this.$nextTick(() => {
          if (!anchor) return false;
          const curAnchor = this.titles.find(({href}) => (href === anchor));
          if (curAnchor) {
            document.querySelector(`#${curAnchor.anchorId}`).click();
          }
        }, 0);
      },

      /**
       * 回复评论，仅响应式时有效
       */
      reply_comment(event) {
        let target = event.target.nodeName !== "A" ?  event.target.parentElement : event.target;
        let item = JSON.parse(target.getAttribute('data-item'));
        let index = parseInt(target.getAttribute('data-index'));

        setTimeout(() => {
          this.is_select = true;
          this.reply_id = parseInt(item.id);
          this.reply_source_id = parseInt(item.source_id);
          this.reply_nick = "回复" + item.nickname + ":";
          this.reply_index = index;
          this.reply_item = item;
        }, 1);
        document.getElementById('reply-input').focus();
      },
      /**
       * html 解码.
       *
       * @param str
       * @returns {string}
       */
      htmlDecodeByRegExp:function (str){
        var s = "";
        if(str.length == 0) return "";
        s = str.replace(/&amp;/g,"&");
        s = s.replace(/&lt;/g,"<");
        s = s.replace(/&gt;/g,">");
        s = s.replace(/&nbsp;/g," ");
        s = s.replace(/&#39;/g,"\'");
        s = s.replace(/&quot;/g,"\"");
        return s;
      },

      /**
       * 展示右侧文章导航
       */
      showRightMenu() {
        this.show_left_offcanvas = true;
      },
      /**
       * 展示左侧用户目录导航
       */
      showCatalogMenu() {
        this.$Bus.$emit('clickFixedCatalogueBtn');
      },
      /**
       * 显示发布详情时间
       */
      showPublishTimeDetail() {
        this.show_publish_time = this.article_info.publish_time;
      },

      /**
       * 显示修改详情时间
       */
      showModifyTimeDetail() {
        this.show_modify_time = this.article_info.modify_time;
      },

      // 监听图片加载事件
      monitorImgLoad() {
        const domRenderContent = document.querySelector('.render-content');
        if (!domRenderContent) return false;
        const iNodes = domRenderContent.querySelectorAll('img');
        let throttled = throttle(() => {
          this.handleHashChange();
          this.getTitles();
        }, 1000);
        this.$nextTick(() => {
          iNodes.forEach((iNode) => {
            if (iNode.complete) {
              preImg(iNode);
            } else {
              iNode.onload = () => {
                // let begin = Date.now();
                preImg(iNode);
                throttled();
                // console.log("iNode.onload", Date.now() - begin);
              }
            }
          });
        }, 0);
      },
      handleScroll(e) {
        let scrollTop = document.scrollTop || document.body.scrollTop || document.documentElement.scrollTop; // 当前滚动距离
        this.titles.forEach((element, index) => {
          if ((scrollTop) >= element.offsetTop) { // 当前滚动距离大于某一目录项时。
            for (let i = 0; i < index; i++) {
              this.titles[i].isActive = false; // 同一时刻，只能有一个目录项的状态位为Active，即此时其他目录项的isActive = false
            }
            element.isActive = true; // 将对应的目录项状态位置为true
          } else {
            element.isActive = false;
          }
        });
      },
      handleDocLoaded() {
        if (window.g_fhFormat) {
          const anchors = document.querySelectorAll('.render-content img');
          anchors.forEach((a) => {
            const src = a.getAttribute('src');
            // 没有':'则为相对路径
            if (src.indexOf(":") === -1) {
              const match = src.match(/\w+.jpg/);
              if (match) {
                a.setAttribute('src', "/pic/" + match.toString());
              }
            }
          });
        }
      },
      handleClickAnchor(data) {
        this.titles.map(({id}) => {
          removeClass(document.getElementById(id), 'active-content');
        });
        const targetEle = document.getElementById(data.id);
        if (targetEle) {
          addClass(targetEle, 'active-content');
          this.scrollTo(targetEle.offsetTop);
          window.location.hash = data.href;
        } else {
          this.scrollTo(data.offsetTop);
        }
        this.show_left_offcanvas = false;
      },
      scrollTo(offsetTop) {
        document.documentElement.scrollTop = offsetTop;
        document.body.scrollTop = offsetTop;
      },

      /**
       * 文章列表（包括响应式的）定位到当前文章
       */
      scrollIntoCurrentArt() {
        document.querySelectorAll(".file-on").forEach((ele) => {
          ele.scrollIntoViewIfNeeded();
        });
      },

      /**
       * titles 中同时返回列表结构和树形结构：
       * 所有目标元素按在文档中出现的顺序放入返回的数组中，同时以 parent/children 组织为树形结构
       * 其中第一个节点为虚拟的根元素
       */
      getTitles() {
        console.log('getTitles');
        // 初始化根节点
        let result = [{
          title: this.article_info.title,
          offsetTop: 0,
          isActive: false,
          lv: 0,
          children: [],
          href: "#",
        }];
        const domRenderContent = document.querySelector('.render-content');
        if(!domRenderContent) return false;
        const titles = domRenderContent.querySelectorAll('h1,h2,h3,h4,h5,h6');
        const names = [];
        titles.forEach((element) => {
          const lv = parseInt(element.tagName.substr(1));
          const uid = uuid(10, 16);
          const id = element.id || `h${lv}-${uid}`;
          names.push(element.innerText);
          const time = findCountInArr(names, element.innerText);
          const hrefName = element.id || `h-${element.innerText}-${time}`;
          element.id = id;
          element.setAttribute('class', 'href-link-title');
          const a = document.createElement('a');
          const i = document.createElement('i');
          a.setAttribute('class', 'href-link');
          a.setAttribute('href', `#${hrefName}`);
          i.setAttribute('class', 'ion-link');
          a.appendChild(i);
          element.appendChild(a);
          result.push({
            title: element.innerText,
            offsetTop: element.offsetTop,
            isActive: false,
            href: `#${hrefName}`,
            id: id,
            lable: element.innerText,
            anchorId: `anchor-${uid}`,
            lv: lv,
            children: [],
          });
        });
        // set parents by lv
        let last = result[0];
        for (let i=1; i<result.length; i++) {
          let current = result[i];
          if (last.lv < current.lv) {
            current.parent = last;
            last.children.push(current);
          } else {
            // 找到第一个比 current 高级的祖先节点
            let dest =  last.parent;
            while (dest.lv >= current.lv) {
              dest = dest.parent;
            }
            current.parent = dest;
            dest.children.push(current);
          }
          last = current;
        }

        this.titles = result;
        this.treeTitles = [result[0]];
      },

      /**
       * 获取评论内容
       */
      getComment(num = 0) {
        // uTODO: 限制发送频率
        if (!this.have_comment) {
          return false;
        }
        return getComment(this.$route.params.detail, num).then((res) => {
          if (res.errno === SUCCESS.code) {
            if (res.data.length) {
              var tmp = [];
              if (document.body.clientWidth <= 650) {
                tmp = parseListForMobile(res.data);
              } else {
                tmp = parseList(res.data);
              }
              tmp.reverse();

              this.comment_list = this.comment_list.concat(tmp);
            }
            if (res.data.length < 5) {
              // 服务器上没有更多评论信息了
              this.have_comment = false;
            }
          }
        }).catch(err => {
          console.error(err);
        });
      },

      /**
       * 文章点赞
       */
      handleArticleLike() {
        if (this.article_info.is_like_bool) {
          return false;
        }

        articleLike(this.article_id).then(res => {
          if (res.errno === SUCCESS.code) {
            this.article_info.is_like_bool = true;
            this.article_info.like_num = res.data;
          }
        });
      },

      /**
       * 提交举报.
       */
      handleArticleReport() {
        // type: 1 文章，2评论
        addReport(this.article_id, 1, this.report_content).then(() => {
          successMsg("举报成功");
          this.dialog_report_visible = false;
          this.report_content = "";
        });
      },

      /**
       * 添加评论
       */
      addComment() {
        if (!this.edit_common_content.trim()) {
          errorMsg('请输入评论内容！');
          return;
        }

        let nickname = this.userInfo.nick;

        let source_id = 0;
        if (this.reply_id && this.reply_source_id) {
          source_id = this.reply_source_id;
        } else if(this.reply_id) {
          source_id = this.reply_id;
        }

        let floor = 0;

        if (this.reply_item) {
          floor = parseInt(this.reply_item.floor) + 1;
        }

        let data = {
          comment_id: this.reply_id,
          aid: this.article_id,
          content: this.edit_common_content,
          source_id: source_id,
          floor: floor
        };

        addComment(data).then((res) => {
          if (res.errno === SUCCESS.code) {
            let showNickName = nickname;
            if (this.reply_item && this.reply_item.nickname) {
              showNickName += "回复" + this.reply_item.nickname;
            }

            let new_child = {
              id        : res.data.id,
              comment_id: this.reply_id,
              content   : this.edit_common_content,
              floor     : floor,
              islike_cnt: 0,
              like_cnt  : 0,
              nickname  : nickname,
              showNick  : showNickName,
              pic       : this.userInfo.pic || null,
              source_id : source_id,
              time      : getDateStr(),
            };
            if (parseInt(source_id) === 0) {
              this.comment_list ? this.comment_list.unshift(new_child) : this.comment_list = [ new_child ];
            } else {
              let data = this.comment_list[this.reply_index];
              data.children ? data.children.push(new_child) : data.children = [new_child];

              Vue.set(this.comment_list, this.reply_index, data);

            }

            successMsg("评论成功");
            this.edit_common_content = "";
            this.clearSelect();
          }
        });
      },

      hiddenImgDialog() {
        this.show_img_dialog = false;
        this.img_dialog_url = "";
      },

      /**
       * 移动端回复清除选中评论
       */
      clearSelect() {
        if (! this.is_select) return;
        this.reply_index = 0;
        this.reply_source_id = 0;
        this.reply_nick = "评论";
        this.reply_id = 0;
        this.is_select = false;
        this.reply_item = null;
      },

      handleCommentLike(id) {
        commentLike(id).then(res => {
          if (parseInt(res.errno) !== SUCCESS.code) {
            return false;
          }

          successMsg("点赞成功");
        });
      },
      handleZoom(){
        this.$store.commit("editor/SET_ZOOM");
      },
      // 从文章列表中递归获取当前文章的路径
      getCurPathRecur(curDir) {
        for (let i = 0; i < curDir.length; i++) {
          const cur = curDir[i];
          if (cur.id === this.article_id) {
            return cur.path;
          }
          if (cur.child.length) {
            const path = this.getCurPathRecur(cur.child);
            if (path) {
              return path;
            }
          }
        }
      },
      handleClickBody(e) {
        // 截获 anchor 点击事件，如果是先对链接，则尝试找到 aid 并跳转
        if (e.target.tagName === "A") {
          let href = e.target.getAttribute('href');
          const hrefURL = new URL(href, location.href);
          // 站内链接
          if (hrefURL.host === new URL(location.href).host) {
            let pathname = hrefURL.pathname;
            const ext = getExtensionFromPath(pathname).toLowerCase();
            // md/html 等格式，尝试获取 aid；否则尝试 router 匹配；其他情况，按浏览器默认规则跳转
            if (["md", "html", "htm"].includes(ext)) {
              const curPath = this.getCurPathRecur(this.$parent.$data.resArticleList.data);
              const base = "http://test.com"; // 仅用于利用 URL 进行路径拼接
              const destURL = (new URL(href, base + "/" + curPath));
              const destPath = decodeURI(destURL.pathname.substring(1));
              const destHash = destURL.hash;
              const uid = this.$route.params.uid;
              // do request
              apis.getAid(destPath, uid).then((res) => {
                if (res.data.aid) {
                  this.$router.push({
                    name: "book-uid-detail",
                    params: {uid, detail: res.data.aid},
                    hash: destHash,
                  });
                } else {
                  infoMsg("文章不存在~");
                }
              });
              e.preventDefault();
              e.stopPropagation();
            } else {
              const match = this.$router.match(pathname);
              // router 匹配则 name 不为空
              if (match.name) {
                // 如果是站内页面，使用 push 方式跳转，避免整页刷新
                this.$router.push(hrefURL.toString().substring(hrefURL.origin.length));
                e.preventDefault();
                e.stopPropagation();
              }
            }
          }
        }
      },
    }
  }
</script>

<style lang="stylus">
  /* 导入全局样式变量 */
  @import '~assets/stylus/variable.styl'

  .svg-container {
    width: 100vw;
    height: 100vh;
    background: white;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1010;
    #svgmap {
      width: 100%;
      height: 100%;
    }
    > div {
      position: fixed;
      top: 10px;
      right: 0;
      div {
        display: inline-block;
        width: 30px;
        font-size: 25px;
        :hover {
          font-size 30px;
        }
      }
    }
  }
  html
    overflow-y: scroll;
    .select-article-wrap {
      .select-article-item {
        padding: 15px 0;
        border-bottom: 1px solid rgba(153,153,153, 0.3);
        font-size: 18px;
        .select-article-item-title-wrap{
          flex: 1;
          display: flex;
          align-items: center;
            .select-article-item-title {
              flex: 1;
              &_path{
                font-size: 12px;
                color: #999999;
              }
            }
        }
        .arrow-icon{
          padding-left 5px;
          color: #333333;
        }
      }
      .select-article-item:last-of-type {
        border-bottom: none;
      }
    }
  .el-tree-wrap{
    .el-tree-node__expand-icon.is-leaf{
      width 0;
      padding: 0;
    }
    .el-tree-node__expand-icon.is-leaf::before{
      content: '';
    }
    .el-tree-node.is-current > .el-tree-node__content {
      background-color: rgba(0,0,0,0.1) !important;
    }
    .el-tree-node__content> .el-tree-node__expand-icon {
      padding: 0;
      padding-right: 6px;
    }
  }

  .href-link-title:hover {
    .href-link {
      color: base_color !important;
      z-index 1
    }
  }
.fixed-catalog-wrap {
  position: fixed;
  opacity 0
  justify-content center;
  bottom: 120px;
  right: 16px;
  width: 50px;
  background-color: #FFF;
  border-radius: 10px;
  box-shadow: 0 3px 9px 1px rgba(146, 146, 146, 0.16);
  transition: all 1s;
  .fixed-catalog-wrap-item {
    position: relative;
    height: 46px;
    display flex
    color: base_color;
    align-items center
    justify-content center
    img {
      width 20px
      height 20px
    }
  }
  .fixed-catalog-wrap-icon{
    img {
      transform rotate(180deg)
    }
  }
  .fixed-catalog-wrap-item::after {
    position absolute
    content ''
    width 21px
    height 1px
    background-color #F4F5F5
    bottom 0
    left 50%
    transform translateX(-50%)
  }
  .fixed-catalog-wrap-item:last-of-type::after {
    display none
  }
}
.nearby-article-wrap-bottom{
  display flex;
  height 60px;
  border-top: 1px solid #eee;
  align-items center;
  padding:0 16px;
}
.nearby-article-wrap-top{
  padding:0 16px;
}
.nearby-article-wrap {
  height 20px;
  width 100%
  display: flex;
  align-items center;
  .nearby-article-item{
    cursor pointer;
    display flex;
    flex: 1;
    height: 20px;
    justify-content flex-end;
    .title{
      display inline-flex
      align-items center
      height: 100%;
    }
    .title-filename{
      height 100%
      position: relative;
      color: #47A679;
      opacity: 0.9;
      font-size: 12px;
    }
    .title-filename::after{
      content: "";
      position: absolute;
      bottom 0;
      left: 0;
      width 100%;
      height: 1px;
      background-color: #1E9863;
      opacity: 0.9;
    }
  }
  .nearby-article-item_right{
    justify-content flex-start
    align-items center
  }
  .nearby-article-home{
    margin 0 17px;
    img {
      width: 20px;
      height: 20px;
    }
  }

}

  .showmenu-right {
    position: fixed;
    bottom: 60px;
    right: 16px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: none;
    padding: 0;
    background: base_color;
    color: #FFF;
    outline: none;
    font-size: 20px;
    display: none;
  }
  .detail-center {
    width: 700px;
    margin: 0 auto;
    margin-top: 75px;

    .article-error {
      text-align: center;
      background: #FFF;
      margin-bottom: 10px;
      border-radius: border_radius;
      padding: 30px 0;
      img {
        text-align: center;
        display: inline-block;
      }
      .small-text {
        font-size: 14px;
      }
      .normal-text {
        font-size: 16px;
        margin-top: 30px;
        line-height: 30px;
      }
    }

    .article-container {
      background #FFF
      border-radius border_radius;
      padding-top: 10px;
      position: relative;
      z-index: 0;

      .toolbar{
        position: absolute;
        right: 15px;
        top: 15px;
        div {
          display: inline-block;
          vertical-align: top;
          margin-left: 10px;
          span {
            font-size: 20px;
          }
        }
      }
      .editormd-html-preview-zoom {
        padding-left 100px;
        padding-right 100px;
      }

      .fh-html {
        font-size 14px;
        padding 0 10px 5px 10px;
        pre {
          padding 5px 0;
          overflow auto;
          white-space pre-wrap;
          font-family: inherit;
        }
        h1, h2, h3, h4, h5, h6 {
          font-size: initial;
        }
        img {
          max-width 100%;
        }
        a {
          &:link {
            color base_color;
          }
          &:hover {
            text-decoration underline;
          }
        }
        .tnd_head {
          display: none;
        }
        #outline {
          display: none;
        }
      }

      .article-info {
        padding 30px 0
        text-align center

        .article-time {
          font-size 14px
          line-height 31px
        }
        .article-title {
          font-size 2.25em
          padding-top: 0 !important;
          margin-top: 0 !important;
          &:before {
            content: none;
          }
        }
        .article-tag {
          line-height 20px;
          span {
            background: #ebf5f3;
            color: base_color;
            padding: 2px 5px;
            margin: 0 5px;
          }
        }
      }

      .article-operator {
        padding: 10px 20px;
        border-top: 1px solid #eee;
        font-size: 14px;

        span {
          margin-right: 20px;
          a {
            cursor: pointer;
          }
        }
      }
    }
  }
  .markdown-toc-list {
    .custom-tree-node_isLeaf{
      padding-left 12px
    }
    position relative
    ul {
      li {
        padding-left 15px
      }
    }
    li {
      padding: 5px 0 0 5px;
      list-style-position: inside;
    }
  }
  .detail-right {
    height: calc(100% - 85px);
    width: 240px;
    position: fixed;
    right: auto;
    margin-left: 960px;
    top: 75px;
    border-radius: border_radius;

    .sidebar, .sticky-block-box{
      height: 100%;
    }
    .sidebar-title {
      text-align center;
      font-size 16px;
      padding 10px 0;
      border-bottom: 1px solid #eee;
    }
    .el-tree-wrap{
      height: 100%;
      .el-tree{
        min-width: 100%;
        display: inline-block !important;
      }
    }
    .sidebar-content {
      padding: 10px;
      height: calc(100% - 43px);
      overflow scroll
      width: 100%;
      white-space:nowrap;
      border-radius: border_radius;
    }
    .custom-tree-node {
      width: 100%;
      .anchor-a{
        display inline-block
        width 100%
      }
    }
    .custom-tree-node_isLeaf{
      padding-left 12px
    }
    .sidebar-content li {
      list-style-type: square;
      list-style-position: inside;
    }

    .sticky-block-box {
      background: #fff;
      border-radius: border_radius;
    }

    .active:before {
      content: "";
      width: 3px;
      background: base_color;
      position: absolute;
      left: -10px;
      height: 20px;
    }
    .active>a {
      color: base_color;
    }

  }

  .comment {
    margin-top: 10px;
    .form-row {
      display: flex;
      flex-direction: row;
      margin: 10px 0;
      background: #FFF;
      padding 10px;
      border-radius border_radius;

      .form-input {
        display inline-block
        flex 1
        text-align right

        textarea {
          display block
          width 100%
          height 100px
          padding 10px
          margin-bottom 10px
          border-color border_color_lv4
          background-color bg_input_color
        }
      }
    }
    .commont-user-info {
      text-align: center;
      display: inline-block;
      margin-right: 20px;

      img {
        width 50px
        height 50px
        border-radius 50%
      }
    }

    .comment-detail {
      background: #FFF;
      padding: 10px;
      border-radius: border_radius;
    }
  }

  /* 重置右侧导航栏的样式 */
  .sidebar,#right-offcanvas {
    .markdown-body ul {
      padding-left: 0;
    }
    .markdown-body a {
      color: important_text_color;
    }
  }
 #right-offcanvas {
   height 100%
  .editormd-preview-container, .editormd-html-preview {
    padding: 10px;
    height: calc(100% - 20px);
  }
   .el-tree-wrap{
     height: 100%;
     min-width: 100%;
     display: inline-block !important;
     .el-tree{
       min-width: 100%;
       display: inline-block !important;
     }
   }
   .custom-tree-node{
     width 100%
     .anchor-a{
       display inline-block
       width 100%
     }
   }
   .custom-tree-node_isLeaf{
       padding-left 12px
   }
 }

  .reference-link{
    position: absolute;
    top: 0;
  }
  .active-content {
    border-bottom: 2px solid base_color !important;
  }
  .href-link {
    position: absolute !important;
    left: -15px;
    font-size: 16px;
    margin-right: 10px;
    color: #FFF !important;
    display: inline-block;
    width: 20px;
    height: 20px;
    z-index: 20;
  }
  .href-link:hover {
    color: base_color !important;
  }

  h5 .href-link, h6 .href-link {
    line-height: 20px;
  }
  h1 .href-link, h2 .href-link {
    line-height: 30px;
  }

  #box {
    h1,h2,h3,h4,h5,h6 {
      margin-left: 10px;
    }
  }

  .time button {
    color: important_text_color;
    &:hover, &:active, &:focus {
      color: important_text_color;
    }
  }

  .el-dialog
    textarea
      border-color border_color_lv4
      background-color bg_input_color

  /**
   * ---------------- 响应式样式 ----------------
   */
  @media (max-width 1200px) {
    .detail-center {
      margin: 0;
      margin-top: 75px;
    }
    .detail-right {
      margin-left: 710px;
    }
  }
  @media (max-width 1200px) {
    .detail-right {
      display: none;
    }
    .detail-center {
      width: 96%;
      padding: 0 10px;
      margin: 0 auto;
      margin-top: 75px;
    }
    .editormd-html-preview {
      /*padding: 0;*/
    }
    .fixed-catalog-wrap {
      opacity 1
    }
  }

  .image-dialog {
    .modal {
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: important_text_color;
      z-index: 13333;
      opacity: 0.3;
    }
    #dialog-img-box {
      position: fixed;
      z-index: 1111111;
      overflow: scroll;
      width: auto;
      height: auto;
    }
  }


  /* 客户端评论 */
  .comment-list {
    background: #FFF;
    padding: 10px;
    border-radius: border_radius;

    .mobile-comment-header {
      display: flex;

      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 20px;
      }

      .mobile-comment-name {
        .name {
          font-size: 14px;
        }
        .time {
          font-size: 12px;
          color: #C0C4CC;
        }
      }

      .mobile-comment-op {
        flex: 1;
        text-align: right;
        /*line-height: 40px;*/
        font-size: 14px;
      }
    }

    .mobile-comment-content {
      margin-left: 60px;
      font-size: 14px;
      margin-bottom: 10px;
    }

    .comment-item {
      border-bottom: 1px solid #eee;
      margin-bottom: 10px;
    }

    .child-comment {
      background: #F2F7FA;
      padding: 10px;
      border-radius: 2px;

      .child-name {
        color: #6AAFFF;
      }
    }

    .mobile-comment-input-box {
      display: flex;
      background: #eee;
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 10px 16px;

      input {
        outline: none;
        flex: 1;
        background: #FFF;
        border: none;
        padding: 5px;
      }

      button {
        background: base_color;
        padding: 8px 13px;
        margin-left: 10px;
        border: none;
        color: #FFF;
        z-index: 999999;
        outline: none;
      }
    }

    .mobile-comment-title {
      text-align: center;
      font-size: 18px;
      margin-bottom: 20px;
      padding-bottom: 10px;
      border-bottom: 1px solid #EEE;
    }

    .comment-loading {
      height: 20px;
      padding: 20px 0;
      z-index: 0;
      /deep/ .el-loading-spinner .circular {
        height: 20px;
        width: 20px;
      }
    }
  }
  @media (max-width 980px) {
    .detail-center {
      width auto!important
      margin-top 48px
      padding 0
    }
  }

</style>
